// extracted by mini-css-extract-plugin
module.exports = {"main-container":"CreateInventoryItemModal_main-container__1BYMO","modal-container":"CreateInventoryItemModal_modal-container__3cQoB"};